export default __webpack_public_path__ + "static/media/fridge1-after1-1920w.d792c48a.webp";